module.exports = __webpack_public_path__ + "img/ep-trefle.bf4a7190.jpg";